import { connect } from "react-redux";
// import { requestAdminAmcs } from "src/redux/actions";
import GeneratedLink from "./generated-link";

const mapStateToProps = (state) => ({
  createdSip: state.adminSip?.createdSip,
});

export default connect(mapStateToProps, {})(GeneratedLink);
